import { render, staticRenderFns } from "./SourEditAbout.vue?vue&type=template&id=84dc2f54&scoped=true&"
import script from "./SourEditAbout.vue?vue&type=script&lang=js&"
export * from "./SourEditAbout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84dc2f54",
  null
  
)

export default component.exports